<!-- SelectedAlertBadges.vue -->
<script lang="ts" setup>
    import MessageBadge from "../../components/Messages/MessageBadge.vue"
    import { ref, computed, onMounted } from 'vue';
    import { IAlertInfo } from '../../lib/Models/Comments/Alerts';
    import { initPinia } from '../../lib/PiniaMgr';
    import { DisplayStyle, IconTypes } from '../../Enums/UiEnums';
    import Icon from '../../components/Icon.vue'
    
    const props = defineProps<{
        alertIds: number[]
    }>();

    const alertOptions = ref<IAlertInfo[]>([]);

    import { useCommentAttributesStore } from '../../lib/Stores/CommentAttributesStore';    
    import { bottomLevelAlertInfoFromIds } from '../../lib/OfficeMd/Comments/CommentHelpers';
    const commentAttributesStore = useCommentAttributesStore(initPinia());

    onMounted(async () =>{
        alertOptions.value = await commentAttributesStore.initAlertInfoHierarchy() ?? [];
    });

    const alertInfo = computed<(IAlertInfo|undefined)[]>(() => {
        return bottomLevelAlertInfoFromIds(props.alertIds, alertOptions.value);
    });

    // Get the alert option
    function getAlertInfoById(id: number): IAlertInfo |undefined {
        if (!alertOptions)
            return;

        for(const option of alertOptions.value)
        {
            if (option.id === id)
                return option;

            for(const childOption of option.children ?? [])
            {
                if (childOption.id === id)
                    return childOption;
            }
        }
    }
</script>

<template>
    <template v-for="alert in alertInfo">
        <MessageBadge v-if="alert">
            <Icon :icon="IconTypes.Notification" :displayStyle="DisplayStyle.Warning"/>
            {{ alert.name }}
        </MessageBadge>
    </template>
</template>